import { KalturaRecordingLean } from '../../composed';
import { createOnDemandResponseProfile } from '../../factories';
import { fetchRecording as requestFetchRecording } from '../../services';

import { processSingleRecording } from './processing';
import { recordingRetrievedProperties } from './utils';

export async function fetchSingleRecording(id: number) {
  const recording = await requestFetchRecording<KalturaRecordingLean>({
    id,
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: recordingRetrievedProperties,
    }),
  });

  return processSingleRecording(recording);
}
